<template>
  <div v-if="item !== null">
    <div
      class="hero hero-cover hero-gradient"
      :style="{ 'background-image': `url(${item.image})` }"
    >
      <div class="container">
        <h1 class="text-white text-center">{{ item.name }}</h1>
      </div>
    </div>

    <div class="section push-content bg-white text-secondary text-justify" v-scroll-reveal>
      <div class="container" v-html="item.part_one"></div>
    </div>

    <div class="section bg-gray-100" v-if="item.part_two" v-scroll-reveal>
      <div class="container _xl pull-content mb-8 md:mb-12 xl:mb-16 xxl:mb-24">
        <figure class="cover cover-image" :style="`background-image: url('/img/services/${item.slug}-middle.jpg')`"></figure>
      </div>

      <div class="container text-secondary text-justify" v-html="item.part_two"></div>
    </div>

    <div class="section">
      <div class="container text-white" v-scroll-reveal>
        <div class="text-justify" v-if="item.part_three" v-html="item.part_three"></div>

        <div class="flex flex-col items-center mt-8 md:mt-12 xl:mt-16 xxl:mt-24">
          <div class="font-bold italic">Želite postati dio naših uspješnih projekata?</div>
          <div class="w-32 border-t-10 border-primary my-4 xl:my-8"></div>
          <router-link :to="{ name: 'contact' }" class="text-white hover:text-primary font-bold italic">Javite se!</router-link>
        </div>
      </div>

      <div
        class="flex flex-col items-center mt-8 md:mt-12 xl:mt-16 xxl:mt-24"
        v-if="project"
        v-scroll-reveal
      >
        <div class="font-light italic">Ili pogledajte projekt vezan uz ovu uslugu</div>
        <div class="w-px h-16 xl:h-20 fhd:h-24 mt-4 xl:mt-8 border-l border-gray-700"></div>
      </div>
      <router-link
        v-if="project"
        tag="figure"
        :to="{ name: 'project', params: { slug: project.slug } }"
        class="cover cover-gradient cursor-pointer flex flex-col items-center justify-center py-8 px-4 md:p-8 min-h-32 md:min-h-48 xl:min-h-96 fhd:min-h-124"
        :style="project.image ? 'background-image: url(' + project.image + ')' : ''"
      >
        <span
          class="font-body leading-tight font-bold italic text-3xl md:text-4xl lg:text-5xl xxl:text-6xl text-white text-center uppercase max-w-md transition"
        >{{ project.name }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
// import Slider from "../partials/Slider";

export default {
//   components: {
//     Slider
//   },

  data() {
    return {
      slug: this.$route.params.slug,
      item: null,
      project: null
    };
  },

  mounted() {
    this.getService();
  },

  methods: {
    getService() {
      this.$http
        .get(`/service/${this.slug}`)
        .then(response => {
          if (!_.isEmpty(response.data.data)) {
            this.item = response.data.data;
            this.project = _.head(this.item.projects);
          }
        })
        .catch(error => {
          console.log(error);
          console.log(error.response);
        });
    }
  }
};
</script>
